module.exports = __webpack_public_path__ + "img/19.b71c4feb.svg";